<template>
  <div class="fzmThankyou">

    <div class="thankyoubody">
        <div class="container">
            <div class="row">

                <div class="col-md-5 offset-md-1">
                    <div class="thankyouInfo">
                        <!-- <h4>ADD A SECOND DELIVERY DAY</h4> -->
                        <h1>Yay! We’re counting down <span class="fzmBreakLine"></span> the days until delivery day.</h1>
                        <p>You will receive a confirmation email soon <span class="fzmBreakLine"></span> with your delivery details.</p>
        
                        <div class="thankyouIcon">
                            <div class="fzmIcon">
                                <img src="@/assets/img/icons/Schedule Icon.svg" alt="">
                            </div>
        
                            <div class="thankyouIconLabel">
                                <div class="thankyouIconLabelMain">
                                    <template v-if="issubscription">
                                        {{$route.params.date | formatdate2}}

                                    </template>

                                    <template v-else>
                                        {{$route.params.date | formatdate}}
                                    </template>
                                </div>
                                <div class="thankyouIconLabelDesc">
                                    <template v-if="issubscription">
                                        <i>Repeating weekly</i>
                                    </template>

                                    <template v-else>
                                        <i>Between {{$route.params.time}}</i>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="thankyouImage">
                        <img src="@/assets/img/thankyouImg.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// components

// plugins
import moment from 'moment'

export default {
    filters : {
        /**
         * Format date
         * formatting date by month and date only
         */
        formatdate(date) {
            return date ? moment(date).format('MMMM DD') : ''
        },
        /**
         * Format date
         * formatting date by day, month and date
         */
        formatdate2(date) {
            return date ? moment(date).format('dddd, MMM DD') : ''
        }
    },
    computed : {
        /**
         * Order type
         */
        issubscription() {
            return this.$store.state.issubscription
        },
        /**
         * date seletedted
         */
        selectedday(){
            return this.$store.state.selectedday
        }
    }
}
</script>

<style lang="scss">
@import '@/scss/global/_mixins.scss';

.fzmThankyou {
    @include screen-up(sm) {
        padding-top : 50px;
    }

    .thankyouIconLabel {
        @include screen-up(sm) {
            text-align: left;
        }
    }
}
</style>